import { NgTemplateOutlet } from '@angular/common';
import { ChangeDetectorRef, Component, DestroyRef, Input, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

import { BillingPlanTier } from '@core/billing-types';
import { NgTemplateAssertType, trackByIndex, trackByProp } from '@core/common-legacy';
import { TranslatePipe } from '@core/i18n-legacy';
import type { TooltipPosition } from '@core/user-interface-legacy';
import { BoxComponent, DividerComponent, IconComponent } from '@core/user-interface-legacy';

import { FeatureItemComponent } from '../feature-item/feature-item.component';
import { ViewMode } from '../plan-picker-2024.types';
import { FeatureCompareLogicService } from './feature-compare-logic.service';
import type {
  AddonModelUI,
  FeatureGroupsUI,
  FeatureItemUI,
  FeatureModelUI,
} from './feature-compare-ui.types';

@Component({
  selector: 'rt-plan-picker-2024-compare',
  templateUrl: './plan-picker-2024-compare.component.html',
  styleUrls: ['./plan-picker-2024-compare.component.less'],
  imports: [
    FeatureItemComponent,
    BoxComponent,
    DividerComponent,
    TranslatePipe,
    NgTemplateAssertType,
    NgTemplateOutlet,
    IconComponent,
  ],
  providers: [FeatureCompareLogicService],
})
export class PlanPicker2024CompareComponent {
  private readonly service = inject(FeatureCompareLogicService);
  private readonly cdRef = inject(ChangeDetectorRef);
  private readonly destroyRef = inject(DestroyRef);

  public readonly ViewMode = ViewMode;
  public readonly FeatureItemTplType: { feature: FeatureItemUI; tooltipPosition?: TooltipPosition };
  public readonly AddonGroupTplType: { addons: FeatureItemUI[]; tooltipPosition?: TooltipPosition };
  public readonly FeatureColumnTplType: {
    groups: FeatureGroupsUI;
    tooltipPosition?: TooltipPosition;
  };
  public readonly startSlots = 5;
  public readonly startDowngradeFeaturesMissingCount = 10;
  public readonly BillingPlanTier = BillingPlanTier;
  public readonly trackByLabel = trackByProp<FeatureItemUI>({ prop: 'label' });
  public readonly trackByIndex = trackByIndex;

  @Input() public viewMode: ViewMode = ViewMode.Default;

  public compareFeaturesModel: FeatureModelUI;
  public compareAddonsModel: AddonModelUI;
  public isLoaded = false;
  public showStartDowngradeWarning = false;

  public ngOnInit() {
    this.service
      .getData$()
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(data => {
        this.compareFeaturesModel = { ...data.features };
        this.compareAddonsModel = { ...data.addons };
        this.showStartDowngradeWarning = data.showStartDowngradeWarning;
        this.isLoaded = true;
        this.cdRef.detectChanges();
      });
  }
}
